import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from './../appservice.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  message: any = {};
  subscription: Subscription;

  constructor(private appservice: AppService, public snackBar: MatSnackBar) {
    this.subscription = this.appservice.getMessage().subscribe(message => {
      this.snackBar.open(message.text, 'Ok', {
        duration: 5000, verticalPosition: 'top'
      });
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
}
